import { useRecoilValue } from 'recoil';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import React from 'react';
import { localeState } from '../../../api/appState';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import { getProductDescription } from '../../../helpers/getProductDescription';

export interface ProductDetailDescriptionProps extends StandardDivProps<ProductDetailDescriptionClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailDescriptionClassKey = 'root' | 'descriptionText' | 'descriptionTextExpanded';

const themeSettings = { name: 'ProductDetailDescription' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.typography.body1,
      color: theme.palette.text.primary,
    },
    descriptionText: {
      position: 'relative',
      overflow: 'hidden',
      maxHeight: 184,
    },
    descriptionTextExpanded: {
      position: 'relative',
      overflow: 'visible',
      height: 'auto',
    },
  }),
  themeSettings,
);

const ProductDetailDescription: React.FC<ProductDetailDescriptionProps> = React.forwardRef(
  ({ className, classes: pClasses, product, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();
    const locale = useRecoilValue(localeState);

    return (
      <div ref={ref} className={clsx(classes.root, className)} {...rest}>
        <div className={clsx(classes.descriptionTextExpanded)}>
          <p>{getProductDescription(product, locale)}</p>
        </div>

        {product.taxonomies?.includes('/pharmakon') && (
          <p>
            <b>{t('productDetailPage/limited')}</b>
          </p>
        )}
      </div>
    );
  },
);

ProductDetailDescription.displayName = 'ProductDetailDescription';

export default withThemeProps(themeSettings)(ProductDetailDescription);
